import CheckoutLineItems from 'my-components/Checkout/CheckoutLineItems';
import DiscountCodeInput from 'my-components/DiscountCodeInput';

import OnlineCoursePurchaseFormCourseItem from './OnlineCoursePurchaseFormCourseItem';

import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';

export default function OnlineCoursePurchaseFormInformation(props) {
  const {
    course,
    disableDiscountCode,
    discountCode,
    header,
    onChangeStep,
    onlineCourse,
    onSubmitPurchase,
    onUpdateDiscountCode,
    paymentDetails,
    purchasing,
  } = props;

  return (
    <>
      <DialogContent>
        {header}
        <div css={({ spacing }) => ({ display: 'flex', flexDirection: 'column', gap: spacing(3) })}>
          <OnlineCoursePurchaseFormCourseItem course={course} onlineCourse={onlineCourse} />
          {!disableDiscountCode && (
            <>
              <Divider />
              <DiscountCodeInput
                ButtonProps={{ variant: 'outlined' }}
                defaultQuery={discountCode?.code}
                onVerified={onUpdateDiscountCode}
                productId={onlineCourse.id}
                productType="OnlineCourse"
                TextFieldProps={{ placeholder: 'Discount code' }}
              />
            </>
          )}
          <Divider />
          <CheckoutLineItems paymentDetails={paymentDetails} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={purchasing}
          variant="contained"
          {...(paymentDetails.total ?
            { children: 'Continue to Payment', onClick: () => onChangeStep(1) }
          : { children: 'Enroll Now', onClick: () => onSubmitPurchase() })}
        />
      </DialogActions>
    </>
  );
}
